let url = new URL(window.location.href);
let variantValue = url.searchParams.get('variant');

function isProductInCart(productId, variantId, inventory) {
  return window.itemsInCart.some(item => {
    if (item.id == variantId || item.product_id == productId) {
      return inventory == 1;
    }
    return false;
  })
}

function calculateTotal(variant) {
  let total = 0;
  let totalStriked = 0;
  let count = 0;
  let originalPrice = 0;
  let price = 0;

  document.querySelectorAll("input[name='checkbox-input']:checked").forEach((checkbox, index) => {
    const productCheckbox = checkbox.closest(".product-checkbox");

    if (variant && variant.price && index === 0) {
      price = variant.price /100
      originalPrice = variant.compare_at_price ? variant.compare_at_price / 100 : 0
    } else {
      price = checkbox.value / 100
      originalPrice = checkbox.dataset.originalPrice ? checkbox.dataset.originalPrice / 100 : 0;
    }
    const productId = checkbox.dataset.productId;
    const variantId = index === 0 ? variantValue || checkbox.dataset.variantId : checkbox.dataset.variantId;
    const inventory = checkbox.dataset.inventory;

    if (isProductInCart(productId, variantId, inventory)) {
      checkbox.closest(".each-item").querySelector(".alert-out-of-stock").style.display = 'block';
    } else {
      checkbox.closest(".each-item").querySelector(".product-checkbox").style.display = 'block';
    }

    if (productCheckbox && window.getComputedStyle(productCheckbox).display === 'block') {
      if (originalPrice > price) {
        totalStriked += originalPrice;
      }

      total += price;
      count++;
    }
  });

  const totalEl = document.querySelector(".count");
  totalEl.textContent = "Rp " + total.toLocaleString("id-ID");

  const strikedPriceEl = document.querySelector(".striked-total");
  if (totalStriked > 0) {
    strikedPriceEl.innerHTML = `<s>Rp ${totalStriked.toLocaleString("id-ID")}</s>`;
  } else {
    strikedPriceEl.textContent = "";
  }

  const buttonEl = document.querySelector("#add-to-cart-button-together");
  const buyAllButton = document.querySelector(".usually-bought-together-buy-button");
  if (count > 0) {
    buttonEl.innerHTML = `Tambah ${count} item ke keranjang`;
    buttonEl.removeAttribute("disabled");
  } else {
    buttonEl.innerHTML = 'Tambah ke keranjang';
    buttonEl.setAttribute("disabled", "true");
  }
  buyAllButton.style.display = "block";
}

const getAllCheckboxes = document.querySelectorAll('input[type="checkbox"][name="checkbox-input"]');
const totalPriceElement = document.querySelector(".total.count"); 
const strikedTotalElement = document.querySelector(".striked-total"); 
const addToCartButton = document.querySelector("#add-to-cart-button-together");

function updateTotal() {
  let getUrl = new URL(window.location.href);
  let getVariant = getUrl.searchParams.get('variant');

  document.querySelectorAll("input[name='checkbox-input']").forEach(checkbox => {
    if(!getVariant) {
      checkbox.addEventListener("change", calculateTotal);
    } else {
      checkbox.addEventListener("change", () => {          
  
        let total = 0;
        let totalStriked = 0;
        let count = 0;
        let originalPrice = 0;
        let price = 0;
      
        document.querySelectorAll("input[name='checkbox-input']:checked").forEach(checkboxVal => {        
          const productCheckbox = checkboxVal.closest(".product-checkbox");
          
          if (window.selectedVariant && window.selectedVariant.price && checkboxVal.dataset.loopindex === "0") {
            price = window.selectedVariant.price / 100;
            originalPrice = window.selectedVariant.compare_at_price ? (window.selectedVariant.compare_at_price / 100) : 0;
          } else {
            price = checkboxVal.value / 100
            originalPrice = checkboxVal.dataset.originalPrice ? checkboxVal.dataset.originalPrice / 100 : 0;
          }
          const productId = checkboxVal.dataset.productId;
          const variantId = getVariant || checkboxVal.dataset.variantId;
          const inventory = checkboxVal.dataset.inventory;
      
          if (isProductInCart(productId, variantId, inventory)) {
            checkboxVal.closest(".each-item").querySelector(".alert-out-of-stock").style.display = 'block';
          } else {
            checkboxVal.closest(".each-item").querySelector(".product-checkbox").style.display = 'block';
          }
      
          if (productCheckbox && window.getComputedStyle(productCheckbox).display === 'block') {
            if (originalPrice > price) {
              totalStriked += originalPrice;
            }
      
            total += price;
            count++;
      
          }
        });
      
        const totalEl = document.querySelector(".count");
        totalEl.textContent = "Rp " + total.toLocaleString("id-ID");
      
        const strikedPriceEl = document.querySelector(".striked-total");
        if (totalStriked > 0) {
          strikedPriceEl.innerHTML = `<s>Rp ${totalStriked.toLocaleString("id-ID")}</s>`;
        } else {
          strikedPriceEl.textContent = "";
        }
      
        const buttonEl = document.querySelector("#add-to-cart-button-together");
        const buyAllButton = document.querySelector(".usually-bought-together-buy-button");
        if (count > 0) {
          buttonEl.innerHTML = `Tambah ${count} item ke keranjang`;
          buttonEl.removeAttribute("disabled");
        } else {
          buttonEl.innerHTML = 'Tambah ke keranjang';
          buttonEl.setAttribute("disabled", "true");
        }
        buyAllButton.style.display = "block";
      })
    }
  })
}

getAllCheckboxes.forEach((checkbox) => {
  const observer = new MutationObserver(() => {
    updateTotal();
  });

  observer.observe(checkbox, {
    attributes: true,
    attributeFilter: ["checked"],
  });

  checkbox.addEventListener("change", updateTotal);
});

updateTotal();

document.addEventListener("DOMContentLoaded", function () {
  if (window.ubtData && !window.isB2B) {
    calculateTotal();
  }
});

function handleAddToCart () {
  let getUrl = new URL(window.location.href);
  let getVariant = getUrl.searchParams.get('variant');

  let selectedProducts = [];
  let variantId = ''
  document.querySelectorAll("input[name='checkbox-input']:checked").forEach((checkbox, index) => {
    const productCheckbox = checkbox.closest(".product-checkbox");
    if (productCheckbox && window.getComputedStyle(productCheckbox).display === 'block') {

      let productId = checkbox.dataset.productId;
      if(index === 0 && getVariant) {
        variantId = getVariant
      } else {
        variantId = checkbox.dataset.variantId
      }

      selectedProducts.push({
        id: variantId,
        quantity: 1,
        productId
      })
    }
  });

  if (selectedProducts.length === 0) {
    return;
  }

  const formData = new FormData();
  formData.append('form_type', 'product');
  selectedProducts.forEach(product => {
    formData.append('id[]', product.id);
    formData.append('quantity[]', product.quantity);
    formData.append('product-id[]', product.productId);
  });

  const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  if (cart) {
    formData.append('sections', cart.getSectionsToRender().map((section) => section.id).join(','));
    formData.append('sections_url', window.location.pathname);
    cart.setActiveElement(document.activeElement);
  }

  const config = fetchConfig('javascript');
  config.headers['X-Requested-With'] = 'XMLHttpRequest';
  delete config.headers['Content-Type'];
  config.body = formData;

  fetch(`${routes.cart_add_url}`, config)
  .then((response) => response.json())
  .then(response => {
    const cartIcon = document.querySelector('.header__icon--cart');
    let cartCountBubble = cartIcon.querySelector('.cart-count-bubble');
    if (cartCountBubble) {
      cartCountBubble.querySelector('span').innerHTML = Number(cartCountBubble.querySelector('span').innerHTML) + selectedProducts.length;
    } else {
      const cartCountBubbleEl = document.createElement('div');
      cartCountBubbleEl.className="cart-count-bubble";
      cartIcon.appendChild(cartCountBubbleEl);
      const cartCountBubbleSpan = document.createElement('span');
      cartCountBubbleSpan.innerHTML = selectedProducts.length
      cartCountBubbleEl.appendChild(cartCountBubbleSpan);
    }
    const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    if (cartNotification && typeof cartNotification.renderContents === 'function') {
      cartNotification.renderContents(response, selectedProducts.length - 1);
    } else {
      console.error("Error in cart drawer");
    }
  })
  .catch(error => {
    console.error(error);
  });
}

function convertToRupiah(number, showTrailingZeros = true){
  const showDecimals = showTrailingZeros || !Number.isInteger(number);
  return new Intl.NumberFormat("id-ID", {
    style: "currency",
    currency: "IDR",
    maximumFractionDigits: showDecimals ? 2 : 0
  }).format(number);
}

function updateProductVariant (variant) {
  window.selectedVariant = variant;

  if (window.ubtData) {
    const productImage = document.querySelector('.product-image');
    productImage.src = variant?.featured_image?.src || window.productFirstAvailableData?.featured_image?.src || window.fullProduct?.featured_image;
    productImage.alt = variant.featured_image?.alt || window.productFirstAvailableData?.featured_image?.alt || 'Product image';
    
    const priceContainer = document.querySelector('.usually-bought-price--container--pdp');
    priceContainer.innerHTML = '';

    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      priceContainer.innerHTML = `
        <div class="price-v2-container usually-bought-price--container--pdp">
          <div class="price-v2-original-price">
            ${convertToRupiah(variant.compare_at_price / 100).slice(0, -3)}
          </div>
          <div class="price-v2-final-price">
            <span class="price-v2-current-price usually-bought-price--container--pdp">
              ${convertToRupiah(variant.price / 100).slice(0, -3)}
            </span>
            <span class="price-v2-discount-amount">
              -${convertToRupiah((variant.compare_at_price - variant.price) / 100).slice(0, -3)}
            </span>
          </div>
        </div>
      `;
    } else {
      priceContainer.innerHTML = `
        <div class="price-v2-container usually-bought-price--container--pdp">
          <div class="price-v2-current-price usually-bought-price--container--pdp">
            ${convertToRupiah(variant.price / 100).slice(0, -3)}
          </div>
        </div>
      `;
    }
    
    const checkboxes = document.querySelectorAll("input[name='checkbox-input']");
    checkboxes.forEach((checkbox, index) => {
      const variantId = index === 0 ? variantValue || checkbox.dataset.variantId : checkbox.dataset.variantId;

      if (variantId === checkbox.dataset.variantId) {
        const inventory = variant.inventory_quantity || checkbox.dataset.inventory;
        if (inventory > 0) {
          checkbox.disabled = false;
          checkbox.closest(".each-item").querySelector(".alert-out-of-stock").style.display = 'none';
        } else {
          checkbox.disabled = true;
          checkbox.closest(".each-item").querySelector(".alert-out-of-stock").style.display = 'block';
        }
      }
    });

    calculateTotal(variant);

  }
}